export default "__VITE_ASSET__B97y4ueO__"